import User from "@/modules/user";

const utmPrefix = "REMOVE_BG_TO_CANVA";
const utmMedium = "acquisitions";
const utmSource = "removebg";

export enum CanvaOnboardingFlow {
  DEFAULT = "editor", // opens Adjust panel within the Image Editor Panel
  IMAGE_EDIT = "image-editor-panel", // opens Image Editor Panel
  // ADJUST
  CROP_PHOTO = "crop-image",
  EXPAND_IMAGE = "image-expander",

  // DESIGN
  ADD_TEXT = "add-text-to-photo",
  USE_TEMPLATE = "design-generation",

  // CUTOUT
  ERASE_DISTRACTIONS = "inpainting-effect",
}

export enum CanvaVariant {
  DEFAULT = "DEFAULT", // A
  WITH_DOCTYPE = "WITH_DOCTYPE", // B
  WITH_DOCTYPE_AND_BRANDING = "WITH_DOCTYPE_AND_BRANDING", // C
  INLINE_EDITOR_DEFAULT = "INLINE_EDITOR_DEFAULT", // IA
  INLINE_EDITOR_ANDROID_APP_DEFAULT = "INLINE_EDITOR_ANDROID_APP_DEFAULT", // IAM
}

export function useCanvaLinkBuilder(flavor: string) {
  const base = flavor === "production" ? "https://canva.com/content-partner" : "https://canva-dev.com/content-partner";

  const buildUrl = (image: string, variant?: CanvaVariant, context?: CanvaOnboardingFlow) => {
    const url = new URL(base);

    url.searchParams.append("image-url", image);

    const variantParam = getVariantParam(variant);
    url.searchParams.append("variant", variantParam);
    url.searchParams.append("utm_campaign", `${utmPrefix}_${variantParam}`);
    url.searchParams.append("utm_medium", utmMedium);
    url.searchParams.append("utm_source", utmSource);

    const onboardingFlow = context ?? CanvaOnboardingFlow.DEFAULT;
    url.searchParams.append("utm_content", onboardingFlow);
    url.searchParams.append("onboarding-flow", onboardingFlow);

    return url.toString();
  };

  const getVariantParam = (variant?: CanvaVariant) => {
    if (!variant) {
      return CanvaVariant.INLINE_EDITOR_DEFAULT;
    }

    if (User.mobileApp() && variant === CanvaVariant.INLINE_EDITOR_DEFAULT) {
      return CanvaVariant.INLINE_EDITOR_ANDROID_APP_DEFAULT;
    }

    return variant;
  };

  return {
    buildUrl,
  };
}
